import { useState, useEffect } from "react";
import { Table, Button, Form, Input } from "antd";
function FoodCardTable(props) {
  let [data, setData] = useState([]);
  useEffect(() => {
    if (props.editData && props.editData.id) {
      if (props.method && props.url) {
        props
          .request({
            url: `${props.url}/${props.editData.id}`,
            method: props.method,
          })
          .then((res) => {
            if (res.success) {
              setData(res.data);
              let amt = 0;
              let qty = 0;
              res.data.map((item) => {
                amt = amt + item.amount;
                qty = qty + item.qty;
              });
              props.form.setFieldsValue({
                amount: amt,
                productqty: qty,
              });
            }
          });
      } else {
        setData(props.editData.products);
      }
    }
  }, [props.editData]);

  useEffect(() => {
    if (props.initData) {
      setData(props.initData);
    }
  }, [props.initData]);

  useEffect(() => {
    props.form.setFieldsValue({
      [props.name]: data,
      qty: data?.length,
      detailqty: data?.length,
    });
    props.form.setFieldsValue({
      amount: data?.reduce(
        (totalHolder, item) => item && totalHolder + item.price,
        0
      ),
    });
    const cols = props.columns();
    data?.map((prod, index) => {
      if (prod) {
        Object.keys(prod).map((key) => {
          let col = cols.find((x) => x.dataIndex === key);
          if (col) {
            props.form.setFieldsValue({
              [`dfield${key}${index}`]: prod[key] ? prod[key] : null,
            });
          }
        });
      } else {
        cols.map((col) => {
          props.form.setFieldsValue({
            [`dfield${col.dataIndex}${index}`]: null,
          });
        });
      }
    });
  }, [data]);

  const handleDelete = (row, pos) => {
    var array = [...data];
    array.splice(pos, 1);
    let removeData = {};
    if (row) {
      Object.keys(row).map((key) => {
        removeData[`dfield${key}${pos}`] = null;
        removeData[`dfieldunitid${pos}`] = null;
      });
    }

    props.form.setFieldsValue({ ...removeData });
    array.map((item, i) => {
      props.form.setFieldsValue({
        [`dfielddiscount${i}`]: 0,
        [`dfielddiscoAmt${i}`]: 0,
      });
    });
    setData(array);
  };

  const addNew = () => {
    var newlist = [...data, null];
    setData(newlist);
  };

  const onChange = ({ value, i, name }) => {
    let newData = [...data];
    if (newData[i] === null) {
      newData[i] = {};
    }
    newData[i][name] = value;
    if (name === "productid") {
      const product =
        props.resproductlist &&
        props.resproductlist.find((x) => x.id === value);
      if (product) {
        newData[i]["productname"] = product.name;
        newData[i]["price"] = product.price;
        props.form.setFieldsValue({
          [`productname`]: product.name,
          [`dfieldprice${i}`]: product.price,
        });
      }
    }
    if (name === "productdrop") {
      const product =
        props.resproductdropdown &&
        props.resproductdropdown.find((x) => x.id === value);
      if (product) {
        newData[i]["productid"] = value;
        newData[i]["productname"] = product.name;
        newData[i]["price"] = product.price;
        props.form.setFieldsValue({
          ["productid"]: value,
          [`productname`]: product.name,
          [`dfieldprice${i}`]: product.price,
        });
      }
    }
    if (newData[i].qty && newData[i].price) {
      let amount = newData[i].qty * newData[i].price;
      newData[i].amount = amount;
      let sum = newData.reduce(
        (totalHolder, item) => {
          if (item.amount && item.amount > 0)
            return {
              sum: totalHolder?.sum + item.amount,
              productQty: totalHolder?.productQty + item.qty,
            };
          return totalHolder;
        },
        {
          sum: 0,
          productQty: 0,
        }
      );
      console.log(sum, "sda");
      props.form.setFieldsValue({
        [`dfieldamount${i}`]: amount,
        amt: sum?.sum,
        amount: sum?.sum,
        price: sum?.sum,
        productqty: sum?.productQty,
      });
    }
    setData(newData);
  };

  return (
    <div>
      <Table
        columns={[
          ...props.columns(props, onChange),
          {
            title: "Үйлдэл",
            dataIndex: "edit",
            align: "center",
            width: 120,
            render: (_, record, index) => (
              <a onClick={() => handleDelete(record, index)}>Устгах</a>
            ),
          },
        ]}
        dataSource={data}
        size="small"
        pagination={false}
      />
      <Form.Item hidden initialValue={data} name={props.name}>
        <Input />
      </Form.Item>
      <Button
        className="w-full flex justify-center my-2"
        type="dashed"
        danger
        onClick={addNew}
      >
        {props.buttonText ? props.buttonText : "Шинэ бараа"}
      </Button>
    </div>
  );
}

export default FoodCardTable;
